import { render, staticRenderFns } from "./AddNewObjectOrder.vue?vue&type=template&id=1a22ae7c&scoped=true"
import script from "./AddNewObjectOrder.vue?vue&type=script&lang=js"
export * from "./AddNewObjectOrder.vue?vue&type=script&lang=js"
import style0 from "./AddNewObjectOrder.vue?vue&type=style&index=0&id=1a22ae7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a22ae7c",
  null
  
)

export default component.exports